import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiReportingGetNextWeekOverview } from "../../../api/reporting/reporting";


const NextWeekOverview = (props) => {
    const navigate = useNavigate();
    const [propertyId, setPropertyId] = useState(props.propertyId)
    const [tasks, setTasks] = useState();
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState();

    const getTasks = () => {
        setLoading(true);
        const fetchTasks = async () => {
            apiReportingGetNextWeekOverview(propertyId)
                .then(res => {
                    if (res.status === 401){
                        navigate("/login", {
                            state: {
                                "redirectURL": "/dashboard/alerts"
                            }
                        })
                    }
                    return res.json()
                })
                .then(res => {
                    if (res.success === "true") {
                        setTasks(res.data)
                    } else {
                        setErrorMessage(res.msg)
                    }
                    setLoading(false);
                })
                .catch(err => {
                    console.log("ERROR: ", err)
                    setLoading(false);
                })
        }
        fetchTasks();
    }

    useEffect( () => {
        getTasks();
    }, [])

    return (
        <>
        <div className="metric-large-title">
            Next 7 days
        </div>
        <div className="metric-large-table">
            <table className="table">
                <thead>
                    <tr>
                        <th></th>
                        <th className="text-center">Checkout</th>
                        <th className="text-center">Refresh</th>
                        <th className="text-center">Total</th>
                    </tr>
                </thead>
                <tbody>

                    {loading ? 
                        <tr>
                            <td colSpan={4}>Loading</td>
                        </tr>
                        
                        : 
                            tasks ?

                                tasks.map( (task) => {
                                    return(
                                        <tr key={task.date}>
                                            <td>{task.date}</td>
                                            <td className="text-center">{task.totalCheckoutTasks}</td>
                                            <td className="text-center">{task.totalRefreshTasks}</td>
                                            <td className="text-center">{task.totalTasks}</td>
                                        </tr>
                                    )
                                })
                            
                            :
                                <tr>
                                    <td colSpan={4}>
                                        No data available
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        </div>
        </>
    )
}

export default NextWeekOverview;